import { render, staticRenderFns } from "./RelatoriosMensageria.vue?vue&type=template&id=01a1ab40"
import script from "./RelatoriosMensageria.vue?vue&type=script&lang=js"
export * from "./RelatoriosMensageria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a1ab40')) {
      api.createRecord('01a1ab40', component.options)
    } else {
      api.reload('01a1ab40', component.options)
    }
    module.hot.accept("./RelatoriosMensageria.vue?vue&type=template&id=01a1ab40", function () {
      api.rerender('01a1ab40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RelatoriosMensageria.vue"
export default component.exports